import { Directive, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CryptoOnboardingFacade } from '@zero/self-service/domain';
import { CustomerStateFacade } from '@zero/shared/util-global-state';

@Directive()
export class CryptoOnboardingPageBase {
  public readonly cryptoOnboardingFacade = inject(CryptoOnboardingFacade);
  public readonly customerStateFacade = inject(CustomerStateFacade);
  public readonly activatedRoute = inject(ActivatedRoute);

  public init() {
    this.cryptoOnboardingFacade.loadOnboardingStatus();
    this.customerStateFacade.loadContactData(true);
  }
}
